<template>
  <SectionSplit
    class="BondholdersTrusteeNotice"
    src="../../assets/landing-landowners/plants.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.BondholdersTrusteeNotice {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Notice to bondholders and trustee",
    "paragraphs": [
      "Under section (e)(ii) “Financial reporting” of Clause 10 “Special Undertakings” of the General Terms and Conditions of the bonds, ISIN code LT0000409963 (the <strong>Bonds</strong>), (the <strong>Terms and Conditions</strong>) of Sun Investment Group, UAB (legal entity code 302662621, registered office address Gedimino ave. 44A-501, Vilnius, Republic of Lithuania) (the <strong>Issuer</strong>) it is defined that Issuer shall prepare semi-annual interim unaudited consolidated and semi-annual interim unaudited stand-alone financial reports of the Issuer (hereinafter – <strong>Financial Reports</strong>) and publish them on the Issuer‘s website www.suninvestmentgroup.com not later than in 3 (three) months after the expiry of relevant interim period.",
      "Issuer hereby informs that the Issuer will be late in publishing Financial Reports on its website, as required by the Terms and Conditions of the Bonds.",
      "The delay is due to unforeseen circumstances and temporary resource constraints.",
      "The Issuer fully understands the importance of timely reporting and assures bondholders and the trustee that it is actively working to finalize and publish the Financial Reports as soon as possible, and in any case no later than 30 October 2025.",
      "The Issuer apologizes for any inconvenience this delay may cause and thanks bondholders and trustee for their understanding."
    ]
  },
  "lt": {
    "title": "Pranešimas obligacijų turėtojams ir patikėtiniui",
    "paragraphs": [
      "Pagal Bendrųjų obligacijų sąlygų 10 straipsnio „Specialūs įsipareigojimai“ dalies (e)(ii) „Finansinė atskaitomybė“ nuostatas, taikomas obligacijoms, kurių ISIN kodas LT0000409963 (toliau – <strong>Obligacijos</strong>), (toliau – <strong>Sąlygos</strong>) „Sun Investment Group“, UAB (juridinio asmens kodas 302662621, buveinės adresas Gedimino pr. 44A-501, Vilnius, Lietuvos Respublika) (toliau – <strong>Leidėjas</strong>) įsipareigojo parengti pusmečio tarpines neaudituotas konsoliduotas ir pusmečio tarpines neaudituotas atskiras finansines ataskaitas (toliau – <strong>Finansinės ataskaitos</strong>) ir paskelbti jas Leidėjo interneto svetainėje www.suninvestmentgroup.com ne vėliau kaip per 3 (tris) mėnesius po atitinkamo laikotarpio pabaigos.",
      "Leidėjas informuoja, kad Finansinės ataskaitos nebus paskelbtos Leidėjo interneto svetainėje nustatytu laiku, kaip tai numatyta Obligacijų Sąlygose.",
      "Vėlavimas atsirado dėl nenumatytų aplinkybių ir laikino žmogiškųjų išteklių trūkumo.",
      "Leidėjas puikiai supranta savalaikės atskaitomybės svarbą ir užtikrina obligacijų turėtojus bei obligacijų turėtojų patikėtinį, kad deda visas pastangas kuo greičiau užbaigti ir paskelbti Finansines ataskaitas, bet ne vėliau kaip iki 2025 m. spalio 30 d.",
      "Leidėjas atsiprašo už galimus nepatogumus, kuriuos gali sukelti šis vėlavimas, ir dėkoja obligacijų turėtojams bei patikėtiniui už supratingumą."
    ]
  }
}
</i18n>
